import { useState } from "react";
import { Save, X } from "lucide-react";

import { api, apiError } from "@/lib/api";

export default function QuoteEditModal({ clients, quote, onClose, onSaved }) {
  const [clientId, setClientId] = useState(quote.client.id);
  const [initialPercent, setInitialPercent] = useState(quote.inicial_porcentaje);
  const [months, setMonths] = useState(quote.meses || 1);
  const [observations, setObservations] = useState(quote.observaciones || "");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");
    try {
      const response = await api.put(`/quotes/${quote.id}`, {
        client_id: clientId,
        lot_id: quote.lot.id,
        initial_percent: Number(initialPercent),
        months: Number(months),
        observations,
      });
      onSaved(response.data);
    } catch (error) {
      setMessage(apiError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="user-edit-modal" data-testid="quote-edit-modal">
      <form className="user-edit-form" data-testid="quote-edit-form" onSubmit={save}>
        <button
          aria-label="Cerrar edición de cotización"
          className="icon-button modal-close"
          data-testid="close-quote-edit-button"
          onClick={onClose}
          type="button"
        >
          <X size={18} />
        </button>
        <span className="eyebrow">EDITAR COTIZACIÓN</span>
        <h2>Manzano {quote.lot.manzano} · Lote {quote.lot.lote}</h2>
        <p className="operation-note">
          El lote se conserva para proteger la trazabilidad comercial de la propuesta.
        </p>
        <label htmlFor="edit-quote-client">Cliente</label>
        <select
          data-testid="edit-quote-client-select"
          id="edit-quote-client"
          onChange={(event) => setClientId(event.target.value)}
          required
          value={clientId}
        >
          {clients.map((client) => (
            <option key={client.id} value={client.id}>
              {`${client.nombre} · ${client.ci}`}
            </option>
          ))}
        </select>
        <label htmlFor="edit-quote-initial">Inicial (%)</label>
        <input
          data-testid="edit-quote-initial-input"
          id="edit-quote-initial"
          max="100"
          min="0"
          onChange={(event) => setInitialPercent(event.target.value)}
          required
          step="0.01"
          type="number"
          value={initialPercent}
        />
        <label htmlFor="edit-quote-months">Cantidad de cuotas</label>
        <input
          data-testid="edit-quote-months-input"
          id="edit-quote-months"
          max="120"
          min="1"
          onChange={(event) => setMonths(event.target.value)}
          required
          type="number"
          value={months}
        />
        <label htmlFor="edit-quote-observations">Observaciones</label>
        <textarea
          data-testid="edit-quote-observations-input"
          id="edit-quote-observations"
          onChange={(event) => setObservations(event.target.value)}
          value={observations}
        />
        {message && <p className="form-error" data-testid="quote-edit-error">{message}</p>}
        <button
          className="primary-button"
          data-testid="save-quote-edit-button"
          disabled={saving}
          type="submit"
        >
          <Save size={16} />
          {saving ? "Recalculando..." : "Guardar y recalcular"}
        </button>
      </form>
    </div>
  );
}